import React, { Children } from 'react';
import { motion } from 'framer-motion';
const cuisineItems = [{
  id: 1,
  src: 'https://cdn.magicpatterns.com/uploads/4o6UMAKuxdcPBdQQTKPVY2/unnamed.webp',
  alt: 'Asados en horno de leña',
  caption: 'Asados en horno de leña'
}, {
  id: 2,
  src: 'https://cdn.magicpatterns.com/uploads/7hg175tSvH6WLHHEfSzx96/unnamed_(2).webp',
  alt: 'Cocina casera de temporada',
  caption: 'Cocina casera de temporada'
}, {
  id: 3,
  src: 'https://cdn.magicpatterns.com/uploads/8rd1diyWDqkWkKz1KDziz6/unnamed_(3).webp',
  alt: 'Entrantes y raciones',
  caption: 'Entrantes y raciones'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: 'easeOut'
    }
  }
};
export function CuisineSection() {
  return <section id="cocina" className="py-24 bg-laura-dark text-laura-cream" data-id="element-72">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-73">
        <div className="text-center mb-16" data-id="element-74">
          <motion.span initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-laura-olive text-sm font-bold uppercase tracking-[0.2em] mb-4 block" data-id="element-75">
            Nuestra Cocina
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-5xl font-playfair mb-6" data-id="element-76">
            Tradición gastronómica de la Vega del Tajuña
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-lg text-laura-beige/80 max-w-2xl mx-auto font-light leading-relaxed" data-id="element-77">
            Cocina casera tradicional madrileña con productos de la zona. Todo
            preparado con recetas de siempre y muchas opciones aptas para
            celíacos.
          </motion.p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-78">
          {cuisineItems.map(item => <motion.div key={item.id} variants={itemVariants} className="group cursor-pointer" data-id="element-79">
              <div className="relative overflow-hidden rounded-lg aspect-[4/5] mb-4" data-id="element-80">
                <div className="absolute inset-0 bg-black/30 group-hover:bg-black/10 transition-colors duration-500 z-10" data-id="element-81" />
                <img src={item.src} alt={item.alt} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700 ease-out" data-id="element-82" />
              </div>
              <h3 className="text-center font-playfair text-xl text-laura-beige group-hover:text-laura-amber transition-colors duration-300" data-id="element-83">
                {item.caption}
              </h3>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}